import { toggle } from "./toggle";

export default toggle("dependencies-enabled");
